
<div class="uploader-status" style = "display:flex;">
  <mat-spinner></mat-spinner>
</div>
